export default __webpack_public_path__ + "static/media/q.61150c36.jfif";